// Phase 0 POC pages — now lives at /demo, no auth required.
import { Link } from "react-router-dom";
import { Shield, Sparkles, ArrowLeft } from "lucide-react";
import Wordmark, { AiBadge } from "@/components/Wordmark";
import MinutesDrafter from "@/components/MinutesDrafter";
import OwnerQA from "@/components/OwnerQA";

export default function Demo() {
  return (
    <div className="min-h-screen" data-testid="demo-page">
      <header className="border-b bg-white" style={{ borderColor: "var(--border)" }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <ArrowLeft size={16} style={{ color: "var(--slate)" }} />
            <Wordmark size={28} />
          </Link>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border" style={{ borderColor: "var(--border)", color: "var(--slate)", background: "var(--slate-light)" }} data-testid="demo-badge">
            <Sparkles size={11} /> Demo · No login required
          </span>
        </div>
      </header>

      <section className="border-b bg-white bg-grid" style={{ borderColor: "var(--border)" }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-12 lg:py-16">
          <div className="max-w-3xl">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]" style={{ color: "var(--navy)" }} data-testid="demo-hero-title">
              Live AI demos.
            </h1>
            <p className="mt-4 text-base max-w-2xl leading-relaxed" style={{ color: "var(--slate)" }}>
              Try the two flagship Opstrait tools right now — no signup, no scheme setup. State-aware for NSW &amp; QLD.
            </p>
            <div className="mt-5 flex items-center gap-3 flex-wrap">
              <AiBadge />
              <span className="inline-flex items-center gap-1.5 text-[11px] font-medium px-2.5 py-1 rounded-full border" style={{ borderColor: "var(--border)", color: "var(--slate)", background: "white" }}>
                <Shield size={11} /> AFSL-safe · general info only
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-10 lg:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          <MinutesDrafter />
          <OwnerQA />
        </div>
      </section>

      <footer className="border-t bg-white" style={{ borderColor: "var(--border)" }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <Wordmark size={18} />
          <p className="text-xs italic max-w-2xl" style={{ color: "var(--tagline-grey)" }} data-testid="demo-footer-disclaimer">
            Opstrait is an AI-assisted operations tool, not a substitute for your strata manager, lawyer, or licensed financial adviser. All AI output is general information only.
          </p>
          <Link to="/login" className="text-xs font-semibold hover:underline" style={{ color: "var(--blue)" }}>
            Sign in →
          </Link>
        </div>
      </footer>
    </div>
  );
}
